import React, { useState } from 'react';
import { Button } from './';

/**
 * Page d'erreur fatale affichée lorsqu'un service critique est indisponible
 */
function FatalErrorPage({ error }) {
  const [showDetails, setShowDetails] = useState(false);
  
  // Traiter l'entrée d'erreur - peut être un objet structuré ou une simple chaîne
  const errorObj = typeof error === 'object' ? error : {
    type: 'generic_error',
    message: error || "Une erreur critique s'est produite",
    solutions: ["Contactez l'administrateur système."]
  };
  
  // Extraire les données d'erreur
  const { type, message, solutions = [], details } = errorObj;
  
  // Déterminer les classes CSS en fonction du type d'erreur
  let bgColor = "bg-red-50";
  let iconBgColor = "bg-red-100";
  let iconColor = "text-red-600";
  let titleColor = "text-red-600";
  let buttonBg = "bg-red-600";
  let buttonHover = "hover:bg-red-700";
  let buttonRing = "focus:ring-red-500";
  
  if (type === 'worker_unavailable') {
    bgColor = "bg-orange-50";
    iconBgColor = "bg-orange-100";
    iconColor = "text-orange-600";
    titleColor = "text-orange-600";
    buttonBg = "bg-orange-600";
    buttonHover = "hover:bg-orange-700";
    buttonRing = "focus:ring-orange-500";
  } else if (type === 'unknown_error') {
    bgColor = "bg-purple-50";
    iconBgColor = "bg-purple-100";
    iconColor = "text-purple-600";
    titleColor = "text-purple-600";
    buttonBg = "bg-purple-600";
    buttonHover = "hover:bg-purple-700";
    buttonRing = "focus:ring-purple-500";
  }
  
  // Déterminer le titre en fonction du type d'erreur
  let title = "Erreur fatale";
  if (type === 'worker_unavailable') title = "Service indisponible";
  if (type === 'encryption_service_unavailable') title = "Erreur de configuration";
  if (type === 'unknown_error') title = "Erreur inattendue";

  return (
    <div className={`flex flex-col items-center justify-center min-h-screen ${bgColor} p-4`}>
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
        <div className={`flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full ${iconBgColor}`}>
          <svg 
            className={`w-6 h-6 ${iconColor}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        <h1 className={`mb-4 text-2xl font-bold text-center ${titleColor}`}>
          {title}
        </h1>
        
        <div className="mb-4 text-sm text-center text-gray-700">
          <p className="mb-2">
            Une erreur critique s'est produite et l'application ne peut pas fonctionner correctement.
          </p>
          <p className="font-medium">
            {message}
          </p>
        </div>
        
        {solutions.length > 0 && (
          <div className="p-4 mb-4 text-sm bg-gray-100 rounded">
            <p className="font-bold mb-2">Solutions suggérées :</p>
            <ul className="list-disc pl-5 space-y-1">
              {solutions.map((solution, index) => (
                <li key={index} className="text-gray-700">{solution}</li>
              ))}
            </ul>
          </div>
        )}
        
        {details && (
          <div className="mb-4">
            <Button 
              variant="link"
              size="sm"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? "Masquer les détails techniques" : "Afficher les détails techniques"}
            </Button>
            
            {showDetails && (
              <div className="mt-2 p-3 text-xs bg-gray-800 text-gray-200 rounded overflow-auto max-h-40 font-mono">
                <pre>{details}</pre>
              </div>
            )}
          </div>
        )}
        
        <div className="flex justify-center">
          <Button
            variant={type === 'worker_unavailable' ? 'warning' : type === 'unknown_error' ? 'info' : 'danger'}
            onClick={() => window.location.reload()}
          >
            Réessayer
          </Button>
        </div>
      </div>
    </div>
  );
}

export default FatalErrorPage;
